export class TagInput extends HTMLElement {
  constructor(domain_id, existing_tags=[], required_groups=[]) {
    super();
    this.domain_id = domain_id;
    this.selected_tags = existing_tags;
    this.required_groups = required_groups
    this.deleted_rows = [];
  }

  async connectedCallback(){
    console.log(this.selected_tags)
    this.available_tags = new DataBinder(`/admin/domains/${this.domain_id}/tags`, true)
    await this.available_tags.fetchData();
    this.innerHTML =
      `
      <div class="row">
        <label>Tags</label>
        <br>
        <span>This can help organize and identify your campaigns.</span>
        <button class="btn btn-outline-primary ${this.selected_tags.length > 0 || this.required_groups.length > 0 ? "hidden" : ""}" style="margin-left:40px">Add Tag</button>
        <div class="campaign_tags_container" style="margin: 20px 0px"></div>
      </div>
      `;

    this.required_groups.forEach(id => {
      if(!this.selected_tags.filter(tag => tag.tag.tag_group_id == id).length) {
        let tag = {
          tag: {
            tag_group_id: id,
            tag_id: "null"
          },
          tag_value: ""
        }
        this.selected_tags.push(tag)
      }
    });
    this.selected_tags.forEach((tag) => {
      let required = this.required_groups.includes(tag.tag.tag_group_id)
      this.addRow(tag, required)
      // Remove ID from required so only one required row per group ID shows
      if(required) {
        this.required_groups.splice(this.required_groups.indexOf(tag.tag.tag_group_id), 1)
      }
    });

    this.querySelector('button').addEventListener('click', function(e) {
      e.preventDefault();
      e.target.classList.add("hidden");
      this.addRow();
    }.bind(this));
  }

  addRow(tag = null, required = false) {
    this.querySelector(".campaign_tags_container").appendChild(new TagRow(tag, this.addRow.bind(this), this.removeRow.bind(this), this.tagChange.bind(this), this.available_tags.data, this.selected_tags, required));
    this.tagChange();
  }

  removeRow(row, data) {
    row.remove();
    if(data != null) {
      data._destroy = true;
      this.deleted_rows.push(data);
    }

    if(this.querySelectorAll(".campaign_tags_container tag-row").length == 0) {
      this.querySelector("button").classList.remove("hidden");
    }
    this.tagChange();
  }

  tagChange() {
    this.selected_tags = [];
    this.querySelectorAll(".campaign_tags_container tag-row").forEach((tagElem) => {
      let tag = tagElem.getData();
      if(tag.tag_id != null) this.selected_tags.push(tag.tag_id)
    });

    this.querySelectorAll(".campaign_tags_container tag-row").forEach((tagElem) => tagElem.updateAvailableTags(this.selected_tags));
  }

  validate() {
    let isValid = true;
    this.querySelectorAll('select').forEach(sel => sel.classList.remove('error'))
    this.getData().forEach((tag) => { if(tag.tag_id == null) isValid = false } )
    this.querySelectorAll('select').forEach(sel => sel.value == 'null' ? sel.classList.add('error') : null)
    return isValid;
  }

  getData() {
    let data = [];
    this.querySelectorAll(".campaign_tags_container tag-row").forEach( (tagElem) => data.push(tagElem.getData()) );
    return data.concat(this.deleted_rows);
  }
}

customElements.define('tag-input', TagInput);

class TagRow extends HTMLElement {
  constructor(tag, addRow, removeRow, tagChange, available_tags, selected_tags, required) {
    super();
    this.tag = tag;
    this.addRow = addRow;
    this.removeRow = removeRow;
    this.tagChange = tagChange;
    this.available_tags = available_tags;
    this.selected_tags = selected_tags;
    this.required = required;
    this.groups = this.available_tags.filter((value, index, self) =>
      index === self.findIndex((g) =>(
        g.tag_group_id === value.tag_group_id
      ))
    );
  }

  async connectedCallback() {
    this.innerHTML = 
      `
      <div class="row">
        ${this.groups.length > 1 ? 
          `<div class="col-md-4 no-gutters">
            <label>Tag Group</label>
            <select type="text" class="form-control" id="tag_group" value="">
              <option value="null">Select</div>
            </select>
          </div>` 
        : ''}       
        <div class="col-md-4">
          <label>Tag Name</label>
          <select type="text" class="form-control" id="tag_name" value="">
            <option value="null">Select</div>
          </select>
        </div>
        <div class="col-md-2 no-gutters">
          <label>Value</label>
          <input type="text" class="form-control" id="tag_value" placeholder="Optional" value="" maxlength="60">
        </div>
        <div class="col-md-2 dni-url-add" style="line-height:30px;">
          <a class="remove_row"><span class="fa fa-minus ${this.required ? 'hidden' : ''}"></span></a>
          <a class="add_row"><span class="fa fa-plus"></span></a>
        </div>
      </div>
      `;

    if(this.groups.length > 1) {
      let all_group_ids = this.groups.map((group) => group.auto_group_id)
      let group_ids = [...new Set(all_group_ids)]
      let group_options_org = group_ids.map(id => this.groups.filter(obj => obj.auto_group_id == id))
      let group_options = group_options_org.map(arr => {
        if(arr.length > 0) {
          return `<optgroup label="${arr[0].auto_group_name}">${arr.map(obj => `<option value="${obj.tag_group_id}">${obj.tag_group_name}</option>`).join("")}</optgroup>`
        } else {
          return ''
        }
      })
      this.querySelector("#tag_group").innerHTML = `<option value="null">Select</option>${group_options}`;
      this.querySelector("#tag_group").onchange = (e) => {this.groupChange(e.target.value)}
    }
    this.querySelector("#tag_name").onchange = (e) => {this.tagChange()}

    if(this.tag != null) {
      if(this.groups.length > 1) {
        this.querySelector('#tag_group').value = this.tag.tag.tag_group_id;
        if(this.required) {
          this.querySelector('#tag_group').setAttribute("disabled", true);
        }
      }
      this.querySelector('#tag_name').value = this.tag.tag.tag_id;
      this.querySelector('#tag_value').value = this.tag.tag_value;
    } else if(this.tag == null && this.groups.length == 1) {
      this.querySelector("#tag_name").setAttribute("disabled", true);
      this.querySelector("#tag_value").setAttribute("disabled", true);
    }

    this.querySelector(".fa-plus").addEventListener("click", () => this.addRow() )
    this.querySelector(".fa-minus").addEventListener("click", () => this.removeRow(this, this.tag))
  }

  getData() {
    let tag_id = this.querySelector('#tag_name').value;
    let tag_value = this.querySelector('#tag_value').value.trim();
    let tag = this.tag != null ? this.tag : {};
    tag.tag_id = tag_id != "null" ? Number(tag_id) : null,
    tag.tag_value = tag_value != "" ? tag_value : null
    return tag;
  }

  updateAvailableTags(selected_tags) {
    let currentGroup = this.querySelector("#tag_group") ? this.querySelector("#tag_group").value : this.groups[0].tag_group_id;
    let currentValue = this.querySelector("#tag_name").value || this.tag.tag.tag_id;
    let new_available_tags = this.available_tags.filter((tag) => tag.tag_id == currentValue || !selected_tags.includes(tag.tag_id))
    let group_tags = new_available_tags.filter(tag => tag.tag_group_id == currentGroup);
    let name_options = currentGroup != 'null' ? group_tags.map((tag) => `<option value="${tag.tag_id}">${tag.tag_name}</option>`).join("") : ''
    this.querySelector("#tag_name").innerHTML = `<option value="null">Select</div>${name_options}`;
    this.querySelector("#tag_name").value = currentValue;
  }

  groupChange(tag_group_id) {
    if(tag_group_id == "null") {
      this.querySelector("#tag_name").setAttribute("disabled", true);
      this.querySelector("#tag_value").setAttribute("disabled", true);
    } else {
      this.querySelector("#tag_name").removeAttribute("disabled");
      this.querySelector("#tag_value").removeAttribute("disabled");
    }
    this.tagChange()
    this.querySelector("#tag_name").value = "null";
  }
}

customElements.define('tag-row', TagRow)

